/********************************************************************************
 * @author       Tech.us
 * @module       UserModule
 * @name         UserLayout
 * @description  Layout component for user interface and navigation
 * @copyright    Tech.us
 * @Createdon    Mar 2025
 * @since        1.0
 *********************************************************************************/

import React,{useEffect,useRef,useState} from 'react';
import { Outlet, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useNavigate,NavLink ,useLocation} from 'react-router-dom';
import { HamrickPrecastMark } from '../../assets/Images/logos'
import Dummy   from '../../assets/Images/backgruonds/askdeep.png'
import { useSelector } from "react-redux";
import CONFIG from '../../config/config.js';
import ScrollToTop from '../../hooks/techus-useTopScroll.js';
import AlertModal from '../../genriccomponents/AlertModal.js';
import { LogOutUser,UserInfoByToken } from '../../services/techus-services.js';
import ReactTooltip from 'react-tooltip';
import Loader from '../../genriccomponents/loaders/RedLoader.js';
import { capitalizeFirstLetter } from '../../utils/commonUtils.js';
import io from 'socket.io-client';

const UserLayout = (props) => {
  const topDiv=useRef()
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const containerRef = useRef(null); 
  const session_data = useSelector((state) => {
    return state?.auth?.user;
  });
  const [show,setShow] =useState(false)
  const [loader,setLoader] =useState(false);
  const getBrowserInfo = () => {
    const userAgent = navigator.userAgent;
    let browserInfo = {};
  
    // Detect browser name and version
    if (/Firefox[\/\s](\d+\.\d+)/.test(userAgent)) {
      browserInfo.name = 'Firefox';
      browserInfo.version = RegExp.$1;
    } else if (/Chrome[\/\s](\d+\.\d+)/.test(userAgent)) {
      browserInfo.name = 'Chrome';
      browserInfo.version = RegExp.$1;
    } else if (/Edge[\/\s](\d+\.\d+)/.test(userAgent)) {
      browserInfo.name = 'Edge';
      browserInfo.version = RegExp.$1;
    } else if (/Safari[\/\s](\d+\.\d+)/.test(userAgent)) {
      browserInfo.name = 'Safari';
      browserInfo.version = RegExp.$1;
    } else {
      browserInfo.name = 'Unknown';
      browserInfo.version = 'Unknown';
    }
  
    return browserInfo;
  };
   const [userData,setUserData] = useState('')
   const token = localStorage.getItem('user_access_token');
   
   const fetchSession = async() => {
    setLoader(true)
    if (!token) {
      throw new Error('No token found');
    }
    try {
      const response = await UserInfoByToken({ token });
      if(response.valid){
        setUserData(response.user)
      }
      setLoader(false)
    } catch (error) {
      throw error;
    }
  };
 


  useEffect(()=>{
    fetchSession()
  },[])

  const getOsInfo = () => {
    const userAgent = navigator.userAgent;
    let osInfo = {};
  
    // Detect OS name and version
    if (/(Windows NT ([\d\.]+))/.test(userAgent)) {
      osInfo.name = 'Windows';
      const fullVersion = RegExp.$1;
      const versionParts = fullVersion.split(' ').pop().split('.'); // Split by spaces and dots
      osInfo.version = versionParts[0]; // Get major version (e.g., 10)
    } else if (/(Mac OS X [\d_]+)/.test(userAgent)) {
      osInfo.name = 'Mac OS X';
      osInfo.version = RegExp.$1.replace(/_/g, '.');
    } else if (/(Linux [a-z0-9_\.\/-]+)/i.test(userAgent)) {
      osInfo.name = 'Linux';
      osInfo.version = 'Unknown'; // Not easy to determine specific Linux version from userAgent
    } else {
      osInfo.name = 'Unknown';
      osInfo.version = 'Unknown';
    }
    return osInfo;
  };
  
  // Usage example to get OS and browser info
  const osInfo = getOsInfo();
  const browserInfo = getBrowserInfo();
  
  // Example of how to use these values in an API request header
  const headers = {
    osName: osInfo.name,
    osVersion: osInfo.version,
    browserName: browserInfo.name,
    browserVersion: browserInfo.version,
  };

  const user_data=localStorage.getItem('uuid')
  useEffect(()=>{
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },[navigate,location])

  const dropper = useRef();

  const [isComponentVisible, setIsComponentVisible] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropper?.current && !dropper?.current?.contains(event.target)) {
        setIsComponentVisible(false)
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const user = useSelector((state) => {
    return state.auth?.user;
  });

  const handleLogoutOkay=()=>{
    authLogOut()
  }
  const [showModal,setShowModal] = useState(false)
  const handleLogout = (e) => {
    e.preventDefault();
      setShowModal(true)  

  }
 
  const currentPath = location.pathname;
  const lastPath = currentPath.split('/').pop();
  const params = new URLSearchParams(headers);

  const authLogOut = async()=>{
    setLoader(true);
    const response = await LogOutUser(params)
    if(response.valid){
      localStorage.removeItem("user_access_token");
      localStorage.clear();
      setShowModal(false)
      setLoader(false)
      navigate('/login');
    }else{
      setLoader(false)
      return false
    } 
  }

  const handleProfile = (isAdmin) => {
    session_data?.id ? navigate('/profile?user_id='+session_data.id) : navigate('/profile?user_id='+user_data)

    
    setIsComponentVisible(false)
  }

  const handleMouseEnter = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };
  const imageUrl = true 
  ? `${CONFIG.AWS_ENDPOINT}/user_profile_images/user_image_${user_data}.png?v=${Date.now()}`
  : `${CONFIG.AWS_ENDPOINT}/user_profile_images/dummy.png?v=1`;

  return (

    <div className='main-panels'>
    {loader && <Loader />}
       <ScrollToTop containerRef={containerRef} />
      
       <div className='d-flex'>
  
       <div className='user-panel-top d-flex justify-content-between'>
        <div>
        </div>
        <div />
        <div className="d-flex align-items-center justify-content-end height100" >
        <div id="menu" className={`btn-reset menu-toggle-container ${show ?'menu-toggle':'menu-transition'}`} onClick={(e) => {
                e.preventDefault();
                setShow(show ? false : true);
              }}>
                <span className="icon-menu-bar admin-icon-menu"></span>
              </div>   
                <div ref={dropper} onClick={() => setIsComponentVisible(!isComponentVisible)} className={isComponentVisible ? "profile-container d-flex align-items-center justify-content-end cursor-pointer  user-profile-header-clicker-active px-4" : "profile-container d-flex align-items-center justify-content-end user-profile-header-clicker cursor-pointer px-4"} >
                  <div className='d-flex align-items-end justify-content-center flex-column mt-2'>
                    <p className='m-0 me-3 user-name white-color text-17'>
                    <b> {userData && userData.username?.first_name != undefined ? capitalizeFirstLetter(userData.username?.first_name): ''}</b>
                      </p>
                  <p className='m-0 me-3 user-role white-color'>
  { userData && userData.username?.name != undefined ? userData?.username?.name : '' }
</p>

                  </div>
                  <button className="ms-2 cs-icon-down d-flex align-items-center">
                    <div className="profile-img-container">
                    <img
                        className=" profile-img"
                        src={imageUrl}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null; // prevents looping
                          currentTarget.src = Dummy;
                        }}
                        alt="profile img"
                        loading="lazy" // Use lazy loading for images
                        width="150" // Set appropriate width and height
                        height="150"
                     />                      
                    </div>
                    
                    
                    <div className="icon-down-arrow cs-icon-down  white-color"></div>
                   
                  </button>
                  <i className='text-1 icon-drop-color icon-dropdown-line'></i>
                  {
                    isComponentVisible ? (
                      <div  className={"user-pop"}>
                        <ul>
                          <li>
                            <Link to={ session_data?.id ? '/profile?user_id='+session_data.id : '/profile?user_id='+user_data} onClick={() => handleProfile(true)}   className='user-links user-link-btn'>
                              <div className='pop-log-out-icon'><i className='icon-profile'></i></div>Profile
                            </Link>
                            
                          </li>
                          <li>
                            <Link to='' onClick={handleLogout} className='user-links user-link-btn'>
                              <div className='pop-log-out-icon'><i className='icon-sign-out'></i></div>Log Out
                            </Link>
                            
                          </li>
                        </ul>
                      </div>
                    ) : null
                  }
                </div>
              </div>
      </div>
      <div
      //  onMouseEnter={handleMouseEnter} 
      // onMouseLeave={handleMouseLeave}
        className={`user-aside-container ${show?'aside-toggle':''}`}>
      <img className='user-panel-left-logo-sm' src={HamrickPrecastMark} alt="Hamrick Precast" />

      <ul>


<ReactTooltip id="menu-user-2" className="reacttooltip" type="dark" effect="solid" place="right" delayShow={parseInt("100")} resizeHide={Boolean(false)} />
{/* <li className='fade-in-right'>
  <NavLink to="/dashboard" data-for="menu-user-2" data-tip={`${show? '' :'Dashboard'}`}  className={({ isActive }) => `menu-item-container d-flex align-items-center menu-item-container-toggle ${isActive ? 'dash-active' : ''}`} >
    <span className={`menu-item-i icon-dashboard`} ></span> <span className={`${show? 'text-show typewriter ' :'text-hide'}`}>Dashboard</span>
  </NavLink>
</li> */}
<li className='fade-in-right data-200'>
    <NavLink to="/projects" aria-current="page" data-for="menu-user-2" data-tip={`${show? '' :'Projects'}`}  className={({ isActive }) => `menu-item-container d-flex align-items-center menu-item-container-toggle ${isActive ? 'dash-active' : ''}`}  >
     
      <span className="menu-item-i icon-my-project"></span>   <span className={`${show? 'text-show typewriter ' :'text-hide'}`}>Projects</span>
    
    </NavLink>
  </li> 
<li className='fade-in-right data-100'>
    <NavLink to="/products" data-for="menu-user-2" data-tip={`${show? '' :'Products'}`}  className={({ isActive }) => `menu-item-container d-flex align-items-center menu-item-container-toggle ${isActive ? 'dash-active' : ''}`} >
      <span className={`menu-item-i icon-product`} ></span> <span className={`${show? 'text-show typewriter ' :'text-hide'}`}>Products</span>
    </NavLink>
  </li>
  <li className='fade-in-right data-100'>
    <NavLink to="/customers" data-for="menu-user-2" data-tip={`${show? '' :'Customers'}`}  className={({ isActive }) => `menu-item-container d-flex align-items-center menu-item-container-toggle ${isActive ? 'dash-active' : ''}`} >
      <span className={`menu-item-i icon-customer`} ></span>  <span className={`${show? 'text-show typewriter ' :'text-hide'}`}>Customers</span>
    </NavLink>
  </li>
  <li className='fade-in-right data-100'>
    <NavLink to="/users" data-for="menu-user-2" data-tip={`${show? '' :'Admin Users'}`}  className={({ isActive }) => `menu-item-container d-flex align-items-center menu-item-container-toggle ${isActive ? 'dash-active' : ''}`} >
      <span className={`menu-item-i icon-App-users`} ></span> <span className={`${show? 'text-show typewriter ' :'text-hide'}`}>Admin Users</span>
    </NavLink>
  </li>

<li className='fade-in-right data-300'>
    <NavLink to="/settings/product-price" aria-current="page" data-for="menu-user-2" data-tip={`${show? '' :'Settings'}`}  className={({ isActive }) => `menu-item-container d-flex align-items-center menu-item-container-toggle ${(isActive|| lastPath=='authentication-log'|| lastPath=='configuration-presets'|| lastPath=='add-presets'|| lastPath=='edit-presets' ) ? 'dash-active' : ''}`}  >
      <span className="menu-item-i icon-Admin-users"></span> <span className={`${show? 'text-show typewriter ' :'text-hide'}`}>Settings</span>
    </NavLink>
  </li>

 
</ul>

<div className='fade-in-right data-300 position-absolute w-100' style={{bottom:"0px"}}>
    <NavLink to="/help" aria-current="page" data-for="menu-user-2" data-tip={`${show? '' :'Help'}`}  className={({ isActive }) => `menu-item-container d-flex align-items-center menu-item-container-toggle ${(isActive) ? 'dash-active' : ''}`}  >
      <span className="menu-item-i"><i className='icon-Question'></i></span> <span className={`${show? 'text-show typewriter ' :'text-hide'}`}>Help</span>
    </NavLink>
  </div>
      </div>
    
      <main className={`main-inside-container ${show ? 'main-inside-container-toggle':''}`} ref={topDiv}>
      {loader && <Loader/>}
      <Outlet />
    
      </main>
      </div>
      <footer className={`d-flex justify-content-between footer-container flex-wrap ${show ? 'footer-continer-toggle': ''}`}>
        <div> 
        <span className='footer-span text-14'>
  All rights reserved © {new Date().getFullYear()} Wellington Hamrick Precast
</span>
        </div>
        <div>
        <span className='footer-span text-14'>Privacy Policy | <span className=' text-14'>Terms Of Service</span> </span>
        </div>
        
      </footer>
     { showModal && 
      <AlertModal button={'Log Out'} showModal={showModal} setShowModal={setShowModal} title={"Log Out"} content={'Are you sure you want to Log out?'} handleOkay={handleLogoutOkay}/>
     }
      </div>
  );
};

export default UserLayout;
